import {Component, OnInit} from '@angular/core';
import {ListComponent, ItemComponent} from '../commons/list.component';
import {AppComponent} from 'app/app.component';
import {ConfirmationService, MessageService} from 'primeng/api';
import {ProcessService} from './process.service';
import {Router, ActivatedRoute} from '@angular/router';
import {PartnerGroup} from 'models/beans';
import {AppBreadcrumbService} from '../../app.breadcrumb.service';

@Component({
    selector: 'afm-process',
    templateUrl: '../commons/items.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class ProcessSComponent implements OnInit {

    title : string = 'Process Management'
    
    constructor() {}

    ngOnInit() {
    }

}

@Component({
    templateUrl: '../commons/list.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class ProcessListComponent extends ListComponent implements OnInit {

    constructor(private cs: ConfirmationService, private ms: MessageService,private s: ProcessService, private a: AppComponent, private bs: AppBreadcrumbService) {
        super(cs,ms,s,a,bs);
        this.canAdd = false;
        this.canRemove = false;
    }

    ngOnInit() {
        super.ngOnInit()
        this.title = 'List of Process';
        
    }
    getPath(){
        return 'process';
    }

    getCols(){
        return [
            { field: 'id', header: 'ID' ,placeHolder:'' ,width : '60px' },
            { field: 'name', header: 'Name',placeHolder:'' ,filtered : true,type : 'text'},
            { field: 'alias', header: 'Alias',placeHolder:'',filtered : true,type : 'text' },
            { field: 'version', header: 'Version',placeHolder:'' ,filtered : true,type : 'text'},
            { field: 'formCount', header: 'Form Count' ,placeHolder:'',filtered : true,type : 'numeric'}
        ];
    }
}
@Component({
    templateUrl: './process.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class ProcessComponent extends ItemComponent implements OnInit {
    
    
    partnerGroups : PartnerGroup[] = [];

    constructor(private ms: MessageService, private s: ProcessService,
        private a: AppComponent, private rt: Router, private r: ActivatedRoute, private bs: AppBreadcrumbService) {
        super(ms,s,a,rt,r,bs);
    }

    ngOnInit() {
        super.ngOnInit()
        this.s.getPartnerGroups().then(data => this.partnerGroups = data);
    }
    
    getPath(){
        return 'processs';
    }
    getSuccessMessage(){
        return 'Process save with success';
    }
    getSelectedGroups(items : any[]) : string[]{
        return items ? items.map(item =>  item.name) : [];
    }

}

